import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";
import { TipoContaContabil } from "./conta-contabil-tipo.model";
import { apiName } from "./data.service";

@Injectable()
export class ContaContabilTipoApiService {

  constructor(
    private _restService: RestService,
  ) { }

  onPost(object: TipoContaContabil, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: TipoContaContabil, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":["descricao"],"where":{"ativo":true}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

  onGetApiUrl() {
    return apiName;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil-tipos/shared/conta-contabil-tipo-api.service.ts
 **/